import { MPCColorsField } from "./colors-field";

export module MPCRowField {
    import ColorsField = MPCColorsField.ColorsField;
    export const PermanentlyHidden: string = 'permanently-hidden-row';
    export const UserHidden: string = 'user-hidden-row';

    export class RowField {
        public parentHtmlElement: HTMLElement;
        public rowFieldHtmlElement: HTMLElement;
        public fieldValue: any;
        public imagePath: string;
        public colors: ColorsField;
        public price: string;
        public textModule: string;
        public heading: RowField;
    }
}
